import React from "react";
import IndicatorDto from "@/models/interfaces/dtos/indicators/indicator-dto";
import PathElementDto from "@/models/interfaces/dtos/path-element-dto";

export interface StoreyIndicatorsContextProps {
    isLoading: boolean;
    storeyIndicatorsData: IndicatorDto[] | undefined;
    storeyPathsData: PathElementDto[] | undefined;
}

export const StoreyIndicatorsContext = React.createContext<StoreyIndicatorsContextProps | undefined>(undefined);